import countryConfigHelper from '$lib/helpers/country-config-helper';

export function match(param: string) {
  return countryConfigHelper.getAvailableCountries().includes(param.toUpperCase());
}
